module.exports = __webpack_public_path__ + "img/formula.3a290128.svg";